export default {
  namespaced: true,
  state: {
    rules: [],
  },
  mutations: {
    setRule(state, data) {
      if (data.current == 1) {
        state.rules = data.data
      } else {
        data.data.forEach((ele) => {
          state.rules.push(ele)
        })
      }
    },
  },
  actions: {
    actionSetRule({ commit }, data) {
      commit('setRule', data)
    },
  },
}
